<div class="error__message">
  <span class="icon-cancel">
    <svg
      width="66"
      height="65"
      viewBox="0 0 66 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M65 32.5C65 50.1731 50.6731 64.5 33 64.5C15.3269 64.5 1 50.1731 1 32.5C1 14.8269 15.3269 0.5 33 0.5C50.6731 0.5 65 14.8269 65 32.5Z"
        stroke="#FEA8B8"
      />
      <path
        d="M33 62.5625C49.6031 62.5625 63.0625 49.1031 63.0625 32.5C63.0625 15.8969 49.6031 2.4375 33 2.4375C16.3969 2.4375 2.9375 15.8969 2.9375 32.5C2.9375 49.1031 16.3969 62.5625 33 62.5625Z"
        stroke="#FEA8B8"
        stroke-width="4"
      />
      <path
        d="M43.8705 24.0622L35.4318 32.5L43.8696 40.937C44.1801 41.2621 44.351 41.6958 44.3459 42.1453C44.3408 42.5947 44.16 43.0243 43.8422 43.3422C43.5244 43.6601 43.0948 43.841 42.6454 43.8462C42.1959 43.8515 41.7622 43.6807 41.437 43.3704L33.0008 34.9317L24.563 43.3696C24.2378 43.6799 23.8042 43.8507 23.3547 43.8454C22.9052 43.8402 22.4756 43.6593 22.1579 43.3414C21.8401 43.0235 21.6593 42.5939 21.6541 42.1445C21.649 41.695 21.8199 41.2613 22.1304 40.9362L30.5682 32.4992L22.1304 24.0614C21.8078 23.7388 21.6266 23.3012 21.6266 22.845C21.6266 22.3888 21.8078 21.9514 22.1304 21.6288C22.453 21.3063 22.8905 21.125 23.3467 21.125C23.8029 21.125 24.2404 21.3063 24.563 21.6288L33.0008 30.0667L41.4386 21.6467C41.7609 21.3335 42.1933 21.1593 42.6427 21.1617C43.0921 21.1641 43.5225 21.3429 43.8414 21.6596C44.1603 21.9762 44.3421 22.4054 44.3477 22.8547C44.3533 23.3041 44.1822 23.7377 43.8713 24.0622H43.8705Z"
        fill="#E4002B"
      />
    </svg>
  </span>
  <p class="title">Não foi possível carregar informações</p>
  <p>
    Estamos trabalhando para resolver esse problema.<br />
    Por favor, tente novamente mais tarde e, se o erro persistir, <br />entre em contato com a nossa equipe de atendimento.
  </p>
</div>
